import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { StudyingStatus } from '@brighterly/lib-core-types/discipline/enums'

import { AppRoute } from '@shared/config'

import { useTutorKanbanStore } from './store'

interface MainInfoAssignLimitReturn {
  refActiveStudents: ComputedRef<string>
  refLimit: ComputedRef<string>
  refHref: ComputedRef<string>
}

export const useMainInfoAssignLimit = (): MainInfoAssignLimitReturn => {
  const router = useRouter()
  const tutorKanbanStore = useTutorKanbanStore()

  const refActiveStudents = computed<string>(() => String(tutorKanbanStore.getTutor?.active_students ?? 0))

  const refLimit = computed<string>(() => {
    const limit = tutorKanbanStore.getTutor?.assign_limit
    return limit == null ? 'No limit' : String(limit)
  })

  const refHref = computed<string>(() => router.resolve({
    path: AppRoute.Customers,
    query: {
      tutor_id: String(tutorKanbanStore.getTutor?.id || 0),
      studying_status: StudyingStatus.Active,
    },
  }).href)

  return {
    refActiveStudents,
    refLimit,
    refHref,
  }
}
